import { render, staticRenderFns } from "./SlideContentHackathon.vue?vue&type=template&id=0336f818&scoped=true&"
import script from "./SlideContentHackathon.vue?vue&type=script&lang=js&"
export * from "./SlideContentHackathon.vue?vue&type=script&lang=js&"
import style0 from "./SlideContentHackathon.vue?vue&type=style&index=0&id=0336f818&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0336f818",
  null
  
)

export default component.exports